'use client';
import { useEffect, useRef, useState } from 'react';

import { Checkbox, Modal } from '@mantine/core';
import { noop } from 'lodash';
import { LDFeatureFlags, useUserPreference } from '../../hooks';
import { Button, LDFeature, Spinner } from '../../ui';

// components/TermlyScript.js

export const TermlyPolicyViewer = ({ policyId }: { policyId: string }) => {
  const [isChecked, setIsChecked] = useState(false);
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const [open, setOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const { preference, preferenceLoading, updateLoading, updateUserPreference } =
    useUserPreference('acceptedTsAndCs', false);

  useEffect(() => {
    if (preferenceLoading) {
      setOpen(false);
      return;
    }
    if (preference) {
      setOpen(false);
      return;
    }

    setOpen(true);
  }, [preference, preferenceLoading]);

  const handleAccept = async () => {
    await updateUserPreference(true);
    setOpen(false);
  };

  return (
    <LDFeature
      featureFlag={LDFeatureFlags.SAAS_TERMS_AND_CONDITIONS_ENABLED}
      defaultValue={false}
      flipCondition={false}
    >
      <Modal
        opened={open}
        onClose={noop}
        closeOnClickOutside={false}
        closeOnEscape={false}
        withCloseButton={false}
        fullScreen
      >
        <div className="">
          {(isLoading || preferenceLoading) && <Spinner size={100} />}

          <iframe
            ref={iframeRef}
            onLoad={() => {
              setIsLoading(false);
            }}
            className="w-full h-screen"
            src={`https://app.termly.io/policy-viewer/policy.html?policyUUID=${policyId}`}
          />
        </div>
        {!isLoading && (
          <div className="w-full">
            <div className="w-full flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between p-6 bg-gray-50">
              <div className="flex items-center space-x-2">
                <Checkbox
                  id="terms"
                  label="I have read and agree to the policy"
                  checked={isChecked}
                  onChange={(event) => {
                    setIsChecked(event.target.checked);
                  }}
                />
              </div>
              <Button
                onClick={handleAccept}
                variant={isChecked ? 'primary' : 'disabled'}
                loading={updateLoading}
                text="Accept Policy"
              />
            </div>
          </div>
        )}
      </Modal>
    </LDFeature>
  );
};
